import ChoiceAnswer from "./ChoiceAnswer";

export default ChoiceAnswer;
